var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5538 0.197906C27.5621 0.781457 34.8157 3.9112 37.361 12.749C39.9055 22.6287 33.9222 29.194 30.8323 31.734C24.6111 36.8482 17.6852 36.7818 13.7011 36.9703C9.10284 37.187 5.09138 36.8177 2.54843 36.6527C2.13175 36.6261 -1.99129 36.4704 1.11894 34.3756C4.22917 32.2807 4.57171 29.5554 4.60683 27.3057C4.56391 22.3674 1.35615 16.3567 5.79364 8.977C11.4141 -0.370783 20.1853 -0.329325 23.5538 0.197906Z",
    fill: "#00B3A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLime);
export default __webpack_public_path__ + "static/media/logo_lime.c33324f3e5d6a549cec26e9d3f8d0d1a.svg";
export { ForwardRef as ReactComponent };